import DOMPurify from 'dompurify';

/**
 * Sanitizes HTML content to prevent XSS attacks using DOMPurify
 */
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS: ['p', 'br', 'strong', 'em', 'u', 'a', 'ul', 'ol', 'li'],
    ALLOWED_ATTR: ['href', 'title', 'target'],
    FORBID_TAGS: ['script', 'object', 'embed', 'style', 'form', 'input'],
    FORBID_ATTR: ['onerror', 'onload', 'onclick', 'onmouseover', 'onfocus', 'onblur', 'onchange', 'onsubmit']
  });
};

/**
 * Sanitizes text input by removing potentially harmful characters
 */
export const sanitizeText = (text: string): string => {
  return text
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '') // Remove script tags
    .replace(/<[^>]*>/g, '') // Remove all HTML tags
    .trim();
};

/**
 * Validates and sanitizes email input
 */
export const sanitizeEmail = (email: string): string => {
  return email.toLowerCase().trim();
};

/**
 * Validates that a string contains only safe characters for database queries
 */
export const validateSafeString = (str: string): boolean => {
  // Allow letters, numbers, spaces, and common punctuation
  const safePattern = /^[a-zA-Z0-9\s\-_.!?,:;'"()[\]{}@#$%&*+=<>\/\\|~`]*$/;
  return safePattern.test(str);
};

/**
 * Sanitizes form data object
 */
export const sanitizeFormData = (data: Record<string, any>): Record<string, any> => {
  const sanitized: Record<string, any> = {};
  
  for (const [key, value] of Object.entries(data)) {
    if (typeof value === 'string') {
      sanitized[key] = sanitizeText(value);
    } else {
      sanitized[key] = value;
    }
  }
  
  return sanitized;
};